// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar - Cohérence parfaite */
.tranche-page {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.tranche-page h1 {
  color: #1a202c;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Header avec recherche et bouton d'ajout - Style identique aux autres */
.tranche-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.tranche-header input {
  flex: 1 1;
  min-width: 300px;
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tranche-header input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.tranche-header input::placeholder {
  color: #94a3b8;
}

/* Bouton d'ajout - Style identique aux autres interfaces */
.tranche-btn-add {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  white-space: nowrap;
}

.tranche-btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.tranche-btn-add:active {
  transform: translateY(0);
}

/* Tableau - Style identique aux autres interfaces */
.tranche-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
}

.tranche-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.tranche-table thead th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tranche-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.tranche-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.01);
}

.tranche-table tbody tr:last-child {
  border-bottom: none;
}

.tranche-table tbody td {
  padding: 1rem;
  color: #374151;
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Styles spéciaux pour les valeurs numériques */
.tranche-table tbody td:nth-child(1),
.tranche-table tbody td:nth-child(2) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 600;
  color: #4f46e5;
}

.tranche-table tbody td:nth-child(3) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 600;
  color: #10b981;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));
  border-radius: 4px;
}

/* Bouton de suppression - Style identique aux autres */
.tranche-table tbody td button {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
}

.tranche-table tbody td button:hover {
  background: #fee2e2;
  color: #ef4444;
  transform: scale(1.1);
}

/* Modal overlay - Style identique */
.tranche-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: tranche-modal-fade-in 0.3s ease;
}

@keyframes tranche-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal - Style identique aux autres */
.tranche-modal {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: tranche-modal-slide-up 0.3s ease;
}

@keyframes tranche-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.tranche-modal h2 {
  color: #1a202c;
  margin-bottom: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Formulaire modal - Style identique */
.tranche-modal form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.tranche-modal input {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.tranche-modal input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.tranche-modal input::placeholder {
  color: #9ca3af;
}

.tranche-modal input[type="number"] {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
}

/* Actions de modal - Style identique */
.tranche-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.tranche-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.tranche-modal-actions button[type="submit"] {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.tranche-modal-actions button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
}

.tranche-modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
}

.tranche-modal-actions button[type="button"]:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Responsive - Identique aux autres */
@media (max-width: 1024px) {
  .tranche-page {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .tranche-header {
    flex-direction: column;
    align-items: stretch;
  }

  .tranche-header input {
    min-width: auto;
  }

  .tranche-table {
    font-size: 0.75rem;
  }

  .tranche-table thead th,
  .tranche-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .tranche-modal {
    padding: 1.5rem;
    margin: 1rem;
  }

  .tranche-modal-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .tranche-page h1 {
    font-size: 2rem;
  }

  .tranche-table {
    font-size: 0.7rem;
  }
}

/* Scrollbar personnalisée - Identique */
.tranche-modal::-webkit-scrollbar {
  width: 6px;
}

.tranche-modal::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.tranche-modal::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.tranche-modal::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.tranche-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.tranche-btn-add:focus-visible,
.tranche-modal-actions button:focus-visible,
.tranche-header input:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* Amélioration de l'accessibilité */
.tranche-table tbody td button:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

/* Animations pour les interactions */
.tranche-table tbody tr,
.tranche-btn-add,
.tranche-modal-actions button,
.tranche-header input {
  will-change: transform;
}

/* Message pour tableau vide */
.tranche-table tbody td[colspan="4"] {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
}

/* Effet de survol sur les prix */
.tranche-table tbody tr:hover td:nth-child(3) {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-radius: 4px;
  font-weight: 700;
}

/* Animation des boutons d'action */
.tranche-table tbody td button {
  position: relative;
  overflow: hidden;
}

.tranche-table tbody td button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: -1;
}

.tranche-table tbody td button:hover::before {
  width: 100%;
  height: 100%;
}

/* Style pour les valeurs min/max avec indicateurs */
.tranche-table tbody td:nth-child(2)::after {
  content: " m³";
  font-size: 0.75em;
  color: #6b7280;
  font-weight: normal;
}

.tranche-table tbody td:nth-child(3)::after {
  content: " m³";
  font-size: 0.75em;
  color: #6b7280;
  font-weight: normal;
}

/* Validation visuelle pour les inputs numériques */
.tranche-modal input[type="number"]:valid {
  border-color: #10b981;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05), white);
}

/* Style pour les messages d'erreur (prêt à utiliser) */
.tranche-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #ef4444;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

/* Style pour les messages de succès (prêt à utiliser) */
.tranche-success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border-left: 4px solid #10b981;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

/* Indicateur de devise MAD */
.tranche-table tbody td:nth-child(3)::after {
  content: " 💰";
  font-size: 0.8em;
}

/* Mise en évidence des tranches par ordre croissant */
.tranche-table tbody tr:nth-child(odd) {
  background: rgba(79, 70, 229, 0.02);
}

.tranche-table tbody tr:nth-child(even) {
  background: rgba(124, 58, 237, 0.02);
}

.tranche-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Tranches.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;;EAEE,wDAAwD;EACxD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,gBAAgB;EAChB,cAAc;EACd,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;;;;EAIE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6DAA6D;AAC/D;;AAEA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA,uDAAuD;AACvD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uEAAuE;AACzE","sourcesContent":["/* Container principal avec marge pour la sidebar - Cohérence parfaite */\n.tranche-page {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.tranche-page h1 {\n  color: #1a202c;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Header avec recherche et bouton d'ajout - Style identique aux autres */\n.tranche-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.tranche-header input {\n  flex: 1;\n  min-width: 300px;\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.tranche-header input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.tranche-header input::placeholder {\n  color: #94a3b8;\n}\n\n/* Bouton d'ajout - Style identique aux autres interfaces */\n.tranche-btn-add {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  white-space: nowrap;\n}\n\n.tranche-btn-add:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.tranche-btn-add:active {\n  transform: translateY(0);\n}\n\n/* Tableau - Style identique aux autres interfaces */\n.tranche-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n}\n\n.tranche-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.tranche-table thead th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.tranche-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.tranche-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.01);\n}\n\n.tranche-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.tranche-table tbody td {\n  padding: 1rem;\n  color: #374151;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n/* Styles spéciaux pour les valeurs numériques */\n.tranche-table tbody td:nth-child(1),\n.tranche-table tbody td:nth-child(2) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 600;\n  color: #4f46e5;\n}\n\n.tranche-table tbody td:nth-child(3) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 600;\n  color: #10b981;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));\n  border-radius: 4px;\n}\n\n/* Bouton de suppression - Style identique aux autres */\n.tranche-table tbody td button {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n}\n\n.tranche-table tbody td button:hover {\n  background: #fee2e2;\n  color: #ef4444;\n  transform: scale(1.1);\n}\n\n/* Modal overlay - Style identique */\n.tranche-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: tranche-modal-fade-in 0.3s ease;\n}\n\n@keyframes tranche-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal - Style identique aux autres */\n.tranche-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: tranche-modal-slide-up 0.3s ease;\n}\n\n@keyframes tranche-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.tranche-modal h2 {\n  color: #1a202c;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Formulaire modal - Style identique */\n.tranche-modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.tranche-modal input {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.tranche-modal input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.tranche-modal input::placeholder {\n  color: #9ca3af;\n}\n\n.tranche-modal input[type=\"number\"] {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n}\n\n/* Actions de modal - Style identique */\n.tranche-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.tranche-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.tranche-modal-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.tranche-modal-actions button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);\n}\n\n.tranche-modal-actions button[type=\"button\"] {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.tranche-modal-actions button[type=\"button\"]:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Responsive - Identique aux autres */\n@media (max-width: 1024px) {\n  .tranche-page {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .tranche-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .tranche-header input {\n    min-width: auto;\n  }\n\n  .tranche-table {\n    font-size: 0.75rem;\n  }\n\n  .tranche-table thead th,\n  .tranche-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .tranche-modal {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .tranche-modal-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .tranche-page h1 {\n    font-size: 2rem;\n  }\n\n  .tranche-table {\n    font-size: 0.7rem;\n  }\n}\n\n/* Scrollbar personnalisée - Identique */\n.tranche-modal::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tranche-modal::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.tranche-modal::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.tranche-modal::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.tranche-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.tranche-btn-add:focus-visible,\n.tranche-modal-actions button:focus-visible,\n.tranche-header input:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* Amélioration de l'accessibilité */\n.tranche-table tbody td button:focus {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n/* Animations pour les interactions */\n.tranche-table tbody tr,\n.tranche-btn-add,\n.tranche-modal-actions button,\n.tranche-header input {\n  will-change: transform;\n}\n\n/* Message pour tableau vide */\n.tranche-table tbody td[colspan=\"4\"] {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n}\n\n/* Effet de survol sur les prix */\n.tranche-table tbody tr:hover td:nth-child(3) {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  border-radius: 4px;\n  font-weight: 700;\n}\n\n/* Animation des boutons d'action */\n.tranche-table tbody td button {\n  position: relative;\n  overflow: hidden;\n}\n\n.tranche-table tbody td button::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s ease, height 0.3s ease;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.tranche-table tbody td button:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n/* Style pour les valeurs min/max avec indicateurs */\n.tranche-table tbody td:nth-child(2)::after {\n  content: \" m³\";\n  font-size: 0.75em;\n  color: #6b7280;\n  font-weight: normal;\n}\n\n.tranche-table tbody td:nth-child(3)::after {\n  content: \" m³\";\n  font-size: 0.75em;\n  color: #6b7280;\n  font-weight: normal;\n}\n\n/* Validation visuelle pour les inputs numériques */\n.tranche-modal input[type=\"number\"]:valid {\n  border-color: #10b981;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05), white);\n}\n\n/* Style pour les messages d'erreur (prêt à utiliser) */\n.tranche-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #ef4444;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n/* Style pour les messages de succès (prêt à utiliser) */\n.tranche-success-message {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #059669;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #10b981;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n/* Indicateur de devise MAD */\n.tranche-table tbody td:nth-child(3)::after {\n  content: \" 💰\";\n  font-size: 0.8em;\n}\n\n/* Mise en évidence des tranches par ordre croissant */\n.tranche-table tbody tr:nth-child(odd) {\n  background: rgba(79, 70, 229, 0.02);\n}\n\n.tranche-table tbody tr:nth-child(even) {\n  background: rgba(124, 58, 237, 0.02);\n}\n\n.tranche-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
